import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { AdminService } from 'src/app/services/admin/admin.service';
import { CompanyDTO } from 'src/app/model/company.dto';

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.scss']
})

export class AddCompanyComponent implements OnInit {

  //letterPattern = '[a-zA-z]+';
  letterPattern = /^[a-zA-Z ]*$/;
  companyName = new FormControl('', [Validators.required,this.noWhitespaceValidator,Validators.minLength(3), Validators.pattern('^[^ ]{1}([A-Za-z ])+[A-Za-z ]+$')]);
  shortName = new FormControl('', [Validators.required, this.noWhitespaceValidator,Validators.minLength(3),Validators.pattern('^[^ ]{1}([A-Za-z0-9 ])+[A-Za-z0-9 ]+$')]);
  city = new FormControl('', [Validators.required,this.noWhitespaceValidator,Validators.minLength(3), Validators.pattern('^[^ ]{1}([A-Za-z ])+[A-Za-z ]+$')]);
  branch = new FormControl('', [Validators.required,this.noWhitespaceValidator, Validators.minLength(3),Validators.pattern('^[^ ]{1}([A-Za-z ])+[A-Za-z ]+$')]);
  data: CompanyDTO;
  items:any;
  shortNameStatus: boolean;
  toBeSearched:any;
  arrayObj:any;
  constructor(public dialogRef: MatDialogRef<AddCompanyComponent>, private adminService: AdminService) { }

  ngOnInit() {
    this.getCompanies();
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  getErrorMessage(feild) {
    // console.log(feild);
    
    switch (feild) {
      case 'Company Name':
        return this.companyName.hasError('required') ? 'You Must Enter A Value' :
        this.companyName.hasError('whitespace')?'Please provide valid Company Name':
        this.companyName.hasError('minlength')?'Input must be at least 3 characters' :
          this.companyName.hasError('pattern') ? 'Enter Valid Input' : '';

          case 'Short Name':
            return this.shortName.hasError('required') ? 'You Must Enter A Value' :
            this.shortName.hasError('whitespace')?'Please provide valid Short Name':
            this.shortName.hasError('minlength')?'Input must be at least 3 characters' :
            this.shortName.hasError('pattern') ? 'Enter Valid Input' :
              '';
              
    
          case 'City':
            return this.city.hasError('required') ? 'You Must Enter A Value' :
            this.city.hasError('whitespace')?'Please provide valid City Name': 
            this.city.hasError('minlength')?'Input must be at least 3 characters' :
              this.city.hasError('pattern') ? 'Enter Valid Input' :
             '';
    
          case 'Branch':
            return this.branch.hasError('required') ? 'You Must Enter A Value' :
            this.branch.hasError('whitespace')?'Please provide valid Branch Name': 
            this.branch.hasError('minlength')?'Input must be at least 3 characters' :
              this.branch.hasError('pattern') ? 'Enter Valid Input' :
             
              '';

      default:
        break;
    }

  }

  submit() {
    this.data = {
      'companyName': this.companyName.value,
      'shortName': this.shortName.value,
      'city': this.city.value,
      'branch': this.branch.value
    }

    this.adminService.addCompany(this.data)
      .subscribe(response => {
        this.dialogRef.close("Added");
      }, (error) => {
        this.dialogRef.close("Added");
      });
  }



  getCompanies(){
    this.adminService.getCompanies()
    .subscribe(response =>{
   //   console.log("response after getting companies: ", response);
      
      this.items = response as any;
    
      
      this.toBeSearched = response;

      this.items = this.items.map(data => {
        data.flag = true;
        return data;
      });
    });
  }


  changeShortName() {
    this.shortNameStatus = false;
  //  console.log("items",this.items)
  //  console.log("jsjggsa",this.shortName.value)
    for (let i = 0; i < this.items.length; i++) {
      //this.arrayObj = this.items[i];
  //    console.log("array",this.arrayObj)

      this.items.filter((x) => {
        if (x.shortName === this.shortName.value) {
          this.shortNameStatus = true;
   //       console.log('input-->', this.shortName.value);
        }
      });
    
    }
  }

  getErrorMessageOfCompanyName(){
    return this.companyName.hasError('whitespace') ? "Enter a valid input" : '';
  }

  getErrorMessageOfShortName(){
    return this.shortName.hasError('whitespace') ? 'Enter a valid input' : '';
  }

  getErrorMessageOfCity(){
    return this.city.hasError('whitespace') ? 'Enter a valid input' : '';
  }

  getErrorMessageOfBranch(){
    return this.branch.hasError('whitespace') ? 'Enter a valid input' : '';
  }

  public noWhitespaceValidator(control: FormControl) {
    // console.log('value', control.value);

    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

}
